<template>
    <a-modal
            :title="title"
            :width="640"
            :visible="visible"
            :confirmLoading="confirmLoading"
            okText="确定"
            cancelText="取消"
            @ok="handleSubmit"
            @cancel="handleCancel"
    >
        <a-spin :spinning="confirmLoading">
            <a-form :form="form">
                <a-form-item
                        label="顾客手机号"
                        :labelCol="labelCol"
                        :wrapperCol="wrapperCol"
                >
                    <a-input placeholder="输入顾客手机号" v-decorator="['phone', {rules: [{required: true, min: 2, message: '手机号格式有误',
                    validator: (rule, value, cbfn) => {
                        var reg= /^1[3456789]\d{9}$/;
                        if(!reg.test(value))
                            cbfn('手机号格式有误')
                         cbfn()
                      }}]}]" />
                </a-form-item>
                <a-form-item
                             label="消费金额"
                             :labelCol="labelCol"
                             :wrapperCol="wrapperCol"
                >
                    <a-input type="number" placeholder="输入顾客消费金额" v-decorator="['consumeAmount', {rules: [{type: 'integer', required: true, min: 1, message: '消费金额需为整数，且最小为1', transform: (value) => parseInt(value)}]}, ]" />
                </a-form-item>
                <a-form-item
                             label="赠送积分"
                             :labelCol="labelCol"
                             :wrapperCol="wrapperCol"
                >
                    <a-input type="number" :placeholder="`输入赠送积分数量，最多可赠送${modalData.point}积分`" v-decorator="['amount', {rules: [{type: 'integer', required: true, min: 1, max: modalData.point ,message: `赠送数量需为整数，且最小为1，最大为${modalData.point}`, transform: (value) => parseInt(value)}]}, ]" />
                </a-form-item>
            </a-form>
        </a-spin>
    </a-modal>
</template>

<script>

    import vendorAdminService from "../../../service/vendorAdmin"

    export default {
        data () {
            return {
                // formModal统一数据
                visible: false,
                title: "",
                modalData: {},
                confirmLoading: false,
                form: this.$form.createForm(this),

                labelCol: {
                    xs: { span: 24 },
                    sm: { span: 7 }
                },
                wrapperCol: {
                    xs: { span: 24 },
                    sm: { span: 13 }
                },

            }
        },
        methods: {
            showForm(title, modalData) {
                this.form.resetFields()
                this.visible = true
                this.modalData = modalData
                this.title = title
            },

            handleSubmit () {
                const { form: { validateFields } } = this
                this.confirmLoading = true

                let vm = this
                validateFields((errors, values) => {
                    if (!errors) {
                        vendorAdminService.getConsumerInfo({phone: values.phone}).then((res)=>{
                            if(res.success) {
                                const h = vm.$createElement;
                                vm.$confirm({
                                    title: '请确认',
                                    content: h('div', {}, [
                                        h('p', "赠送信息如下："),
                                        h('p', `顾客手机号：${res.data.phone}`),
                                        h('p', `顾客昵称：${res.data.nickname}`),
                                        h('p', `消费金额：${values.consumeAmount}元`),
                                        h('b', `赠送积分：${values.amount}积分`),
                                    ]),
                                    onOk() {
                                        vm.$emit('pay', {consumerId: res.data.id, consumeAmount: values.consumeAmount, amount: values.amount})
                                    },
                                    onCancel() {
                                        vm.confirmLoading = false
                                    },
                                    okText: "确定",
                                    cancelText: "取消"
                                });
                            } else {
                                const h = vm.$createElement;
                                vm.$warning({
                                    title: '赠送失败',
                                    content: h('div', {}, [
                                        h('p', res.message),
                                    ]),
                                    onOk() {},
                                    okText: "确定"
                                });
                                vm.confirmLoading = false
                            }
                        })
                        .catch((res)=>{
                            vm.confirmLoading = false
                        })
                        /*setTimeout(() => {
                            this.visible = false
                            this.confirmLoading = false
                            values.id = this.modalData.id
                            this.$emit(this.formType === "charge"?'charge':"deduct", values)
                        }, 200)*/
                    } else {
                        this.confirmLoading = false
                    }
                })
            },
            handleCancel () {
                this.visible = false
            }
        },
    }
</script>
